const getRandomName = () => {
  const names = [
    'Alice',
    'Bob',
    'Charlie',
    'David',
    'Eve',
    'Frank',
    'Grace',
    'Hannah',
    'Ivy',
    'Jack',
    'Kathy',
    'Leo',
    'Mona',
    'Nina',
    'Oscar',
    'Paul',
    'Quincy',
    'Rachel',
    'Steve',
    'Tracy',
    'Uma',
    'Victor',
    'Wendy',
    'Xander',
    'Yara',
    'Zane',
  ];
  return names[Math.floor(Math.random() * names.length)];
};

const getRandomNarrativeTitle = () => {
  const titles = [
    'The Future of Finance',
    'Market Trends and Insights',
    'Investment Strategies',
    'Economic Outlook',
    'Company Performance Analysis',
    'Global Economic Shifts',
    'Tech Industry Innovations',
    'Healthcare Sector Developments',
    'Energy Market Dynamics',
    'Consumer Goods Trends',
    'Real Estate Market Analysis',
    'Emerging Markets Opportunities',
    'Cryptocurrency Insights',
    'Sustainable Investing',
    'Financial Risk Management',
  ];
  return titles[Math.floor(Math.random() * titles.length)];
};

const getRandomDisplayName = () => {
  const displayNames = ['Alpha', 'Bravo', 'Charlie', 'Delta', 'Echo'];
  return displayNames[Math.floor(Math.random() * displayNames.length)];
};

export { getRandomName, getRandomNarrativeTitle, getRandomDisplayName };
